/**
 * 图标映射工具
 * 根据路由路径自动匹配对应的 Element Plus 图标
 */

import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { PATH_ICON_MAP, DEFAULT_ICON, type IconPath, type IconName } from './pathIconMapping';

// 导出配置和类型供外部使用
export { DEFAULT_ICON };
export type { IconPath, IconName };

/**
 * 运行时图标映射表（可修改）
 * 初始值为静态配置，可通过 addPathIconMapping 动态扩展
 */
const runtimeIconMap: Record<string, string> = { ...PATH_ICON_MAP };

/**
 * 根据路由路径获取对应的图标
 * @param path 路由路径，如 '/dashboard', '/userList'
 * @returns Element Plus 图标名称
 */
export function getIconByPath(path?: string): string {
  if (!path) {
    return DEFAULT_ICON;
  }

  // 直接查找完整路径
  return runtimeIconMap[path] || DEFAULT_ICON;
}

/**
 * 添加自定义路径图标映射
 * @param path 路由路径
 * @param iconName Element Plus 图标名称
 */
export function addPathIconMapping(path: string, iconName: string): void {
  runtimeIconMap[path] = iconName;
}

/**
 * 批量添加路径图标映射
 * @param mappings 路径到图标的映射对象
 */
export function addPathIconMappings(mappings: Record<string, string>): void {
  Object.assign(runtimeIconMap, mappings);
}

/**
 * 获取当前所有的路径图标映射（只读）
 * @returns 路径图标映射表的副本
 */
export function getPathIconMappings(): Readonly<Record<string, string>> {
  return { ...runtimeIconMap };
}

/**
 * 获取所有可用的 Element Plus 图标名称
 * @returns 图标名称数组
 */
export function getAvailableIcons(): string[] {
  return Object.keys(ElementPlusIconsVue);
}

export default {
  getIconByPath,
  addPathIconMapping,
  addPathIconMappings,
  getPathIconMappings,
  getAvailableIcons
};
